// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/arduino-cloud.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../icons/arduino-cloud-filled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./connected-status-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./offline-status-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./refresh-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-in-title {
    margin: 20px 0;
    font-weight: bold;
}
.sign-in-desc {
    margin: 20px;
    line-height: 150%;
}
.sign-in-cta {
    margin-left: 0 !important;
}
.sign-in-learnmore {
    margin-bottom: 20px;
}

.p-TabBar-tabIcon.cloud-sketchbook-tree-icon {
    background-color: var(--theia-foreground);
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    width: 19px !important;
    height: var(--theia-icon-size);
    -webkit-mask-size: 100%;
}

.p-mod-current .cloud-sketchbook-tree-icon {
    background-color: var(--theia-foreground);
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100%;
}

.sketchbook-trees-container
    .p-TabBar[data-orientation="horizontal"]
    > .p-TabBar-content {
    justify-content: center;
    border-bottom: 1px solid var(--theia-tree-indentGuidesStroke);
}

.sketchbook-trees-container
    .p-Widget.p-TabBar.p-DockPanel-tabBar
    > ul
    > li.p-TabBar-tab
    > div.p-TabBar-tabLabel {
    display: none;
    width: 0px;
    max-width: 0px;
}

.sketchbook-trees-container
    .p-Widget.p-TabBar.p-DockPanel-tabBar
    > ul
    > li.p-TabBar-tab
    > div.p-TabBar-tabCloseIcon {
    display: none;
    width: 0px;
    max-width: 0px;
}

.sketchbook-trees-container
    .p-TabBar[data-orientation="horizontal"]
    .p-TabBar-tab {
    min-width: 55px;
}

.sketchbook-trees-container
    .p-Widget.p-TabBar.p-DockPanel-tabBar
    > ul
    > li.p-TabBar-tab {
    padding-left: 20px;
}

.sketchbook-trees-container
    .p-Widget.p-TabBar.p-DockPanel-tabBar
    > ul
    > li.p-TabBar-tab.p-mod-current {
    border-bottom: 2px solid var(--theia-activityBar-activeBorder);
}

.sketchbook-trees-container .center {
    height: 100%;
    display: flex;
    align-items: center;
}

.cloud-sketchbook-welcome {
    flex-direction: column;
    text-align: center;
}

.cloud-sketchbook-welcome > .item {
    align-items: flex-end;
}

.cloud-sketchbook-welcome > .item .link {
    cursor: pointer;
    color: var(--theia-textLink-foreground);
}

img.arduino-account-picture {
    width: var(--theia-private-sidebar-icon-size);
    height: var(--theia-private-sidebar-icon-size);
    max-width: 100%;
    max-height: 100%;
    border-radius: 50%;
}

.connected-status-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
    width: var(--theia-icon-size);
    height: var(--theia-icon-size);
}

.offline-status-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center center no-repeat;
    width: var(--theia-icon-size);
    height: var(--theia-icon-size);
}

.refresh-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center center no-repeat;
    width: var(--theia-icon-size);
    height: var(--theia-icon-size);
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.rotating {
    animation: rotating 1s ease-in-out infinite;
}

.cloud-connection-status {
    border-top: 1px solid var(--theia-tree-indentGuidesStroke);
    border-bottom: none;
}

.cloud-connection-status .item {
    padding: 8px;
}

.cloud-connection-status .status {
    flex-grow: 2;
}

.cloud-connection-status .actions {
    border-left: 1px solid var(--theia-tree-indentGuidesStroke);
    border-right: 1px solid var(--theia-tree-indentGuidesStroke);
}

.composite-node {
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
}

.composite-node .tree-container {
    height: 100%;
}

.arduino-share-sketch-dialog .sketch-link {
    display: flex;
}

.arduino-share-sketch-dialog .sketch-link input {
    flex: 1;
}

.arduino-share-sketch-dialog .sketch-link-embed textarea {
    width: 100%;
}

.actions.item.flex-line .fa,
.theia-file-icons-js.file-icon .fa {
    font-size: var(--theia-icon-size);
}

.theia-file-icons-js.file-icon.not-in-sync-offline .fa {
    color: var(--theia-activityBar-inactiveForeground);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/cloud-sketchbook.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,qDAA6C;IAC7C,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,qDAAoD;IACpD,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;;;IAGI,uBAAuB;IACvB,6DAA6D;AACjE;;AAEA;;;;;IAKI,aAAa;IACb,UAAU;IACV,cAAc;AAClB;;AAEA;;;;;IAKI,aAAa;IACb,UAAU;IACV,cAAc;AAClB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;;;IAII,8DAA8D;AAClE;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,6CAA6C;IAC7C,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2EAAsE;IACtE,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,2EAAoE;IACpE,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,2EAA6D;IAC7D,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0DAA0D;IAC1D,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2DAA2D;IAC3D,4DAA4D;AAChE;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":[".sign-in-title {\r\n    margin: 20px 0;\r\n    font-weight: bold;\r\n}\r\n.sign-in-desc {\r\n    margin: 20px;\r\n    line-height: 150%;\r\n}\r\n.sign-in-cta {\r\n    margin-left: 0 !important;\r\n}\r\n.sign-in-learnmore {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.p-TabBar-tabIcon.cloud-sketchbook-tree-icon {\r\n    background-color: var(--theia-foreground);\r\n    -webkit-mask: url(../icons/arduino-cloud.svg);\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-repeat: no-repeat;\r\n    width: 19px !important;\r\n    height: var(--theia-icon-size);\r\n    -webkit-mask-size: 100%;\r\n}\r\n\r\n.p-mod-current .cloud-sketchbook-tree-icon {\r\n    background-color: var(--theia-foreground);\r\n    -webkit-mask: url(../icons/arduino-cloud-filled.svg);\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-repeat: no-repeat;\r\n    -webkit-mask-size: 100%;\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-TabBar[data-orientation=\"horizontal\"]\r\n    > .p-TabBar-content {\r\n    justify-content: center;\r\n    border-bottom: 1px solid var(--theia-tree-indentGuidesStroke);\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-Widget.p-TabBar.p-DockPanel-tabBar\r\n    > ul\r\n    > li.p-TabBar-tab\r\n    > div.p-TabBar-tabLabel {\r\n    display: none;\r\n    width: 0px;\r\n    max-width: 0px;\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-Widget.p-TabBar.p-DockPanel-tabBar\r\n    > ul\r\n    > li.p-TabBar-tab\r\n    > div.p-TabBar-tabCloseIcon {\r\n    display: none;\r\n    width: 0px;\r\n    max-width: 0px;\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-TabBar[data-orientation=\"horizontal\"]\r\n    .p-TabBar-tab {\r\n    min-width: 55px;\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-Widget.p-TabBar.p-DockPanel-tabBar\r\n    > ul\r\n    > li.p-TabBar-tab {\r\n    padding-left: 20px;\r\n}\r\n\r\n.sketchbook-trees-container\r\n    .p-Widget.p-TabBar.p-DockPanel-tabBar\r\n    > ul\r\n    > li.p-TabBar-tab.p-mod-current {\r\n    border-bottom: 2px solid var(--theia-activityBar-activeBorder);\r\n}\r\n\r\n.sketchbook-trees-container .center {\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.cloud-sketchbook-welcome {\r\n    flex-direction: column;\r\n    text-align: center;\r\n}\r\n\r\n.cloud-sketchbook-welcome > .item {\r\n    align-items: flex-end;\r\n}\r\n\r\n.cloud-sketchbook-welcome > .item .link {\r\n    cursor: pointer;\r\n    color: var(--theia-textLink-foreground);\r\n}\r\n\r\nimg.arduino-account-picture {\r\n    width: var(--theia-private-sidebar-icon-size);\r\n    height: var(--theia-private-sidebar-icon-size);\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    border-radius: 50%;\r\n}\r\n\r\n.connected-status-icon {\r\n    background: url(\"./connected-status-icon.svg\") center center no-repeat;\r\n    width: var(--theia-icon-size);\r\n    height: var(--theia-icon-size);\r\n}\r\n\r\n.offline-status-icon {\r\n    background: url(\"./offline-status-icon.svg\") center center no-repeat;\r\n    width: var(--theia-icon-size);\r\n    height: var(--theia-icon-size);\r\n}\r\n\r\n.refresh-icon {\r\n    background: url(\"./refresh-icon.svg\") center center no-repeat;\r\n    width: var(--theia-icon-size);\r\n    height: var(--theia-icon-size);\r\n}\r\n\r\n@keyframes rotating {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.rotating {\r\n    animation: rotating 1s ease-in-out infinite;\r\n}\r\n\r\n.cloud-connection-status {\r\n    border-top: 1px solid var(--theia-tree-indentGuidesStroke);\r\n    border-bottom: none;\r\n}\r\n\r\n.cloud-connection-status .item {\r\n    padding: 8px;\r\n}\r\n\r\n.cloud-connection-status .status {\r\n    flex-grow: 2;\r\n}\r\n\r\n.cloud-connection-status .actions {\r\n    border-left: 1px solid var(--theia-tree-indentGuidesStroke);\r\n    border-right: 1px solid var(--theia-tree-indentGuidesStroke);\r\n}\r\n\r\n.composite-node {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n}\r\n\r\n.composite-node .tree-container {\r\n    height: 100%;\r\n}\r\n\r\n.arduino-share-sketch-dialog .sketch-link {\r\n    display: flex;\r\n}\r\n\r\n.arduino-share-sketch-dialog .sketch-link input {\r\n    flex: 1;\r\n}\r\n\r\n.arduino-share-sketch-dialog .sketch-link-embed textarea {\r\n    width: 100%;\r\n}\r\n\r\n.actions.item.flex-line .fa,\r\n.theia-file-icons-js.file-icon .fa {\r\n    font-size: var(--theia-icon-size);\r\n}\r\n\r\n.theia-file-icons-js.file-icon.not-in-sync-offline .fa {\r\n    color: var(--theia-activityBar-inactiveForeground);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
